import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslate } from 'react-admin'
import { useFormikContext } from 'formik'
import { Collapse, Typography } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import VideoLibraryOutlinedIcon from '@material-ui/icons/VideoLibraryOutlined'

import '../../utils/constants/CSS/eventForms.css'
import MyTextField from '../form/fields/MyTextField'
import GAME_EVENT_FORM_BROADCAST_FIELDS from '../../utils/constants/gameEventFormBroadcastFields'
import { isFormFieldDisabled } from '../../utils/helpers/isFieldDisabled'

// Third-party (non-Mismatch) stream link, tucked behind a disclosure at the bottom of the
// Details tab, together with whatever else belongs to third-party streaming (`children`, e.g.
// the Video operator picker). It isn't our streaming, so it stays collapsed by default and
// doesn't draw attention; it opens automatically when the event already has an external link
// or `hasContent` says the children hold a value, so the values are visible when editing.
const ThirdPartyStreamField = ({ state, hasContent = false, children }) => {
  const translate = useTranslate()
  const { values } = useFormikContext()
  const [expanded, setExpanded] = useState(
    Boolean(values[GAME_EVENT_FORM_BROADCAST_FIELDS.THIRD_PARTY_BROADCAST_URL]) || hasContent,
  )
  const toggle = () => setExpanded((v) => !v)

  return (
    <div>
      <div
        role='button'
        tabIndex={0}
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            toggle()
          }
        }}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          cursor: 'pointer',
          userSelect: 'none',
        }}
      >
        <Typography style={{ fontSize: 13, color: '#6B6B6B' }}>
          {translate('ra.gameDrawer.thirdPartyStreamPrompt')}
        </Typography>
        <ExpandMoreIcon
          style={{
            fontSize: 20,
            color: '#9A9A9A',
            transform: expanded ? 'rotate(180deg)' : 'none',
            transition: 'transform 150ms ease',
          }}
        />
      </div>

      <Collapse in={expanded} timeout='auto'>
        <div className='div-flex' style={{ marginTop: 12 }}>
          <VideoLibraryOutlinedIcon className='icon' style={{ fill: 'grey' }} />
          <MyTextField
            name={GAME_EVENT_FORM_BROADCAST_FIELDS.THIRD_PARTY_BROADCAST_URL}
            label={translate('ra.formFields.externalBroadcastUrl')}
            disabled={isFormFieldDisabled(
              state,
              GAME_EVENT_FORM_BROADCAST_FIELDS.THIRD_PARTY_BROADCAST_URL,
            )}
          />
        </div>
        {children && <div style={{ marginTop: 12 }}>{children}</div>}
      </Collapse>
    </div>
  )
}

ThirdPartyStreamField.propTypes = {
  state: PropTypes.string,
  hasContent: PropTypes.bool,
  children: PropTypes.node,
}

export default ThirdPartyStreamField
